const profileStore = {
  birthDate: null,
  gender: '',
  ghinNumber: '',
  hasGhin: false
};
const customerStore = {
  sources: []
};

export const userStore = {
  customer: customerStore,
  email: '',
  firstName: '',
  id: 0,
  lastName: '',
  profile: profileStore
};

export interface IProfileStore {
  birthDate: any;
  gender: string;
  ghinNumber: string;
  handicapCurrent?: string;
  handicapLow?: string;
  handicapModified?: string;
  hasGhin: boolean;
  image?: string;
}

export interface ICustomerStore {
  sources: ISource[];
}

export interface IUserStore {
  customer?: ICustomerStore;
  email: string;
  firstName: string;
  id: number;
  lastName: string;
  profile: IProfileStore;
  isActive?: boolean;
}

export type CreditCardType =
  | 'Visa'
  | 'American Express'
  | 'MasterCard'
  | 'Discover'
  | 'JCB'
  | 'Diners Club'
  | 'Unknown';

export interface ISource {
  brand: CreditCardType;
  country?: string;
  expMonth?: number;
  expYear?: number;
  djstripeId: number;
  last4: string;
}

export interface IStripeToken {
  card: ISource;
  client_ip: string;
  created: number;
  id: string;
}

// TODO: Move to club
export interface IPlayer {
  email: string;
  firstName: string;
  id: number;
  lastName: string;
  isActive?: boolean;
  profile: IProfileStore;
}
